<template>
    <ul class="selectlist">
        <li v-for="key in slotKeys" :key="key"  :class="{'selected' : current === key}" aria-label='Scroll to section'  @click="(e) => {e.preventDefault(); selectionHandler(key)}">
            <slot :name="key" />
        </li>
    </ul>
</template>

<script setup>
    import { ref, useSlots, defineEmits } from 'vue';
 
    const slots = useSlots();
    const slotKeys = Object.keys(slots)
    const current = ref('')
    const emit = defineEmits(['scrollTo']);

    const props = defineProps({
        callBack: {
            type: Function,
            default: () => {}
        },
    })

    const selectionHandler = (key) => {
        current.value = key
        props.callBack({value: key});
        emit('scrollTo', {value: key});
    }
</script>
